/**
 * STOP! READ ME FIRST:
 * This icon library is for legacy compatibility with module dependencies
 * using the older font awesome icon global import pattern. These icons are not directly
 * used in the Peaks application, but by the modules we import instead.
 * If you are using an icon in Peaks, please use Dynamic Icon Imports instead
 * for maintainabiity/performance for modern font awesome icons.
 * https://fontawesome.com/v6/docs/web/use-with/react/add-icons#dynamic-icon-importing
 * LOG:
 * - MAP mfe icons added
 * - removed faGlobe, faUserCircle since they're sandbox only in MAP, fatimes -> fasTimes, +faTimes regular, +fasCheck
 */
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleDown,
  faAngleUp,
  faCalendarDay,
  faCalendarDays,
  faCheck,
  faDollarSign,
  faExclamationCircle,
  faExclamationTriangle,
  faFileAlt,
  faInfoCircle,
  faPen,
  faQuestionCircle,
  faSyncAlt,
  faUniversity,
  faChevronRight as farChevronRight,
  faSpinner as farSpinner,
  faSync as farSync,
  faTimes as farTimes
} from '@fortawesome/pro-regular-svg-icons'
import {
  faExternalLink,
  faCheck as fasCheck,
  faExclamationCircle as fasExclamationCircle,
  faTimes as fasTimes
} from '@fortawesome/free-solid-svg-icons'
import {
  faCalendarAlt,
  faCalendarExclamation,
  faCloudRain,
  faAngleRight as falAngleRight,
  faExclamationCircle as falExclamationCircle,
  faExclamationTriangle as falExclamationTriangle,
  faTimes as falTimes
} from '@fortawesome/pro-light-svg-icons'
import {
  faCircleCheck as fasCircleCheck,
  faCircleExclamation as fasCircleExclamation
} from '@fortawesome/pro-solid-svg-icons'

export default function initGlobalIconLibrary(): void {
  library.add(
    faAngleDown,
    faAngleUp,
    faCalendarAlt,
    faCalendarDay,
    falAngleRight,
    falExclamationCircle,
    faCalendarDays,
    faCalendarExclamation,
    faCheck,
    faCloudRain,
    faDollarSign,
    faExclamationCircle,
    faExclamationTriangle,
    faExternalLink,
    faFileAlt,
    faInfoCircle,
    falExclamationTriangle,
    faPen,
    faQuestionCircle,
    fasExclamationCircle,
    faSyncAlt,
    fasCircleCheck,
    fasCircleExclamation,
    fasExclamationCircle,
    farChevronRight,
    farSpinner,
    falTimes,
    farSync,
    farTimes,
    fasCheck,
    faSyncAlt,
    faUniversity,
    fasTimes,
    falExclamationCircle,
    falAngleRight
  )
}
